import PropTypes from "prop-types";
import styles from "./styles";

export const ErrorMessage = ({ message }) => {
  return <span className={styles.errorMessage}>{message}</span>;
};

ErrorMessage.propTypes = {
  message: PropTypes.string,
};

ErrorMessage.defaultProps = {
  message: "",
};
